import { ComponentProps, useMemo, useState } from 'react'

import { FormRichTextEditor } from 'cng-common/features/form/components/formRichTextEditor/FormRichTextEditor'
import { TOOLBAR_BUTTONS } from 'core-components/library/richTextEditor'

import styles from './CompactFormRichTextEditor.module.scss'

const compactButtons = {
  [TOOLBAR_BUTTONS.Undo]: true,
  [TOOLBAR_BUTTONS.Redo]: true,
  [TOOLBAR_BUTTONS.Bold]: true,
  [TOOLBAR_BUTTONS.Italic]: true,
  [TOOLBAR_BUTTONS.Underline]: true,
  [TOOLBAR_BUTTONS.BulletedList]: true,
  [TOOLBAR_BUTTONS.NumberedList]: true,
  [TOOLBAR_BUTTONS.Link]: true,
}

type Props = Omit<
  ComponentProps<typeof FormRichTextEditor>,
  'toolbarButtonsView' | 'toolbarCustomButtons' | 'toolbarClassName'
>

export const CompactFormRichTextEditor = (props: Props) => {
  const [expanded, setExpanded] = useState(false)
  const toggleLabel = expanded ? 'Less' : 'More'

  const toolbarCustomButtons = useMemo(
    () => [
      {
        title: 'Toggle formatting tools',
        content: () => (
          <button
            type="button"
            className={styles.toggle}
            aria-expanded={expanded}
            disabled={props.isDisabled}
            onMouseDown={(event) => event.preventDefault()}
            onClick={() => setExpanded((value) => !value)}
          >
            {toggleLabel}
            <i
              className={expanded ? 'kbase kbase-chevron-top' : 'kbase kbase-chevron-bottom'}
              aria-hidden="true"
            />
          </button>
        ),
      },
    ],
    [expanded, props.isDisabled, toggleLabel]
  )

  return (
    <FormRichTextEditor
      {...props}
      toolbarClassName={styles.toolbar}
      toolbarButtonsView={expanded ? undefined : compactButtons}
      toolbarCustomButtons={toolbarCustomButtons}
    />
  )
}
